// extracted by mini-css-extract-plugin
module.exports = {"fileStatusContainer":"mrOnboardingFileHistory_fileStatusContainer__11HZS","loadMoreBtnContainer":"mrOnboardingFileHistory_loadMoreBtnContainer__2v2oF"};